export const isInt = (n: number) => n % 1 === 0;
